import { ChangeDetectorRef, Component } from '@angular/core';
import { ScrollToService } from '@df/dom/scroll/scroll-to.service';
import { TranslatePipe } from '@df/ui/translation/translate.pipe';
import { BasketFastCheckoutFormComponent } from '../../../checkout/fast/basket-fast-checkout-form.component';
import { BasketFastCheckoutStepComponent } from '../../../checkout/fast/basket-fast-checkout-step.component';
import { ResultComponent } from '../../../ui/api/result.component';
import { LocalBraintreeApplePayExpressComponentDef } from './local-braintree-apple-pay-express.component.def';

@Component({
    selector: 'braintree-apple-pay-express-basket',
    templateUrl: './braintree-apple-pay-express.html',
    standalone: true,
    imports: [ResultComponent, TranslatePipe]
})
export class BraintreeApplePayExpressBasketComponent extends LocalBraintreeApplePayExpressComponentDef {
    constructor(
        checkoutFormComponent: BasketFastCheckoutFormComponent,
        changeDetectorRef: ChangeDetectorRef,
        scrollToService: ScrollToService,
        checkoutStepComponent: BasketFastCheckoutStepComponent
    ) {
        super(checkoutFormComponent, changeDetectorRef, scrollToService, checkoutStepComponent);
    }
}
